import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconFrontdesk = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.2489 6.00651L8.106 0.75659C7.77086 0.41447 7.22914 0.41447 6.894 0.75659L1.75114 6.00651C1.59 6.17013 1.5 6.39325 1.5 6.62512V13.625C1.5 14.108 1.884 14.5 2.35714 14.5H12.6429C13.116 14.5 13.5 14.108 13.5 13.625V6.62512C13.5 6.39325 13.41 6.17013 13.2489 6.00651ZM7.5 4.5C8.44714 4.5 9.21429 5.28311 9.21429 6.24997C9.21429 7.21596 8.44714 7.99995 7.5 7.99995C6.55286 7.99995 5.78571 7.21596 5.78571 6.24997C5.78571 5.28311 6.55286 4.5 7.5 4.5ZM10.5 11.75C10.5 12.1642 10.1642 12.5 9.75 12.5H5.25C4.83579 12.5 4.5 12.1642 4.5 11.75C4.5 10.5074 5.50736 9.5 6.75 9.5H8.25C9.49264 9.5 10.5 10.5074 10.5 11.75Z",
		stroke: "currentColor"
	})
});
export default SvgIconFrontdesk;
